<template>
  <fieldset class="grade-picker">
    <legend class="grade-picker__legend form__label">Grade</legend>

    <template v-for="g in grades">
      <input
        type="radio"
        :key="`input-${g.key}`"
        :id="g.key"
        :value="g.key"
        name="grade-picker"
        class="grade-picker__input"
        v-model="grade"
        @change="$emit('input', grade)"
      />

      <label
        :key="`label-${g.key}`"
        :for="g.key"
        class="grade-picker__label"
      >
        {{ g.name }}
      </label>
    </template>
  </fieldset>
</template>

<script>
import grades from '@/utils/grades'

export default {
  name: 'GradePicker',

  props: {
    value: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      grades,
      grade: ''
    }
  },

  computed: {
    gradeIds () {
      return Object.keys(this.grades)
    }
  },

  mounted () {
    this.grade = this.value
  }
}
</script>

<style lang="scss">
.grade-picker {
  margin: 1rem 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: .25rem .125rem;
  border: 0;
}

.grade-picker__legend {
  display: flex;
  flex: 1 0 100%;
}

.grade-picker__input {
  position: absolute;
  opacity: 0;
  z-index: -1;
}

.grade-picker__label {
  margin: 0 0.125rem 0.125rem 0;
  padding: .125rem 1rem;
  width: auto;
  height: 2rem;
  display: inline-flex;
  align-items: center;
  border-radius: 2rem;
  font-size: .8rem;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: (1rem / 32);
  color: var(--color-page-fg);
  background-color: var(--color, #CFD8DC);
  border: .125rem solid #FFF;

  &:hover,
  &:active {
    border-color: #78909C;
  }

  :focus + & {
    outline: none;
    box-shadow:
      0 0 0 .125rem var(--color-page-bg),
      0 0 0 .25rem #78909C;
  }

  :checked + & {
    border-color: currentColor;
  }
}
</style>
